import React from 'react';

const Row = ({ affid, subid, country, factor}) => {

    return (
        <tr>
            <td>{affid}</td>
            <td>{subid}</td>
            <td>{country}</td>
            <td>{factor}</td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/PushapiFactorAll/components/Table/components/Row/index.js